import { Plan, PlanPermission } from "@/api/plans";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PlansState } from "./types";

const initialState: PlansState = {
  currentPlan: null,
  availablePlans: [],
  permissions: [],
  isLoading: false,
  error: null,
  hasAttemptedFetch: false,
};

const plansSlice = createSlice({
  name: "plans",
  initialState,
  reducers: {
    setCurrentPlan(state, action: PayloadAction<Plan>) {
      state.currentPlan = action.payload;
    },
    setAvailablePlans(state, action: PayloadAction<Plan[]>) {
      state.availablePlans = action.payload;
    },
    setPermissions(state, action: PayloadAction<PlanPermission[]>) {
      state.permissions = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setHasAttemptedFetch(state, action: PayloadAction<boolean>) {
      state.hasAttemptedFetch = action.payload;
    },
    clearPlansData(state) {
      state.currentPlan = null;
      state.availablePlans = [];
      state.permissions = [];
      state.error = null;
      state.hasAttemptedFetch = false;
    },
  },
});

export const {
  setCurrentPlan,
  setAvailablePlans,
  setPermissions,
  setLoading,
  setError,
  setHasAttemptedFetch,
  clearPlansData,
} = plansSlice.actions;

export default plansSlice.reducer;
